export const GalleryResourceTypes = {
  PHOTOS: 'photos',
  VIDEOS: 'videos',
  MESSAGES: 'video-message',
};

export const MAX_VIDEO_UPLOADS = 10;

export const MAX_PHOTO_UPLOADS = 10;

export const UPLOAD_LIMITS = {
  [GalleryResourceTypes.PHOTOS]: {
    max: MAX_PHOTO_UPLOADS,
    warningKey: 'GALLERY_PHOTO_UPLOAD_LIMIT_WARNING',
  },
  [GalleryResourceTypes.VIDEOS]: {
    max: MAX_VIDEO_UPLOADS,
    warningKey: 'GALLERY_VIDEO_UPLOAD_LIMIT_WARNING',
  },
};

export const GalleryUploadStatus = {
  QUEUED: 'queued',
  UPLOADING: 'uploading',
  SUCCESS: 'success',
  FAILED: 'failed',
};
